var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{key:_vm.tableName,staticClass:"ma-4"},[_c('SysTableCRUD',{attrs:{"headers":_vm.headers,"tableName":_vm.tableName,"title":_vm.title,"parentTables":_vm.parentTables,"primaryKey":_vm.primaryKey}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }